// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const KYC_BIZUM_SOCKET_MESSAGE = {
  endpoint: '/v1/checkout/orders/identification',
  payload: {
    orderId: getCheckoutIdFromUrl(),
  },
};

export { KYC_BIZUM_SOCKET_MESSAGE };
